import React, { lazy } from "react";

const LazyCreateAssessment = lazy(() => import("./CreateAssessment"));

const CreateAssessment = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyCreateAssessment {...props} />;

export default CreateAssessment;
